import type { LucideIcon } from 'lucide-react';
import {
  Bell,
  BellRing,
  Clock,
  DollarSign,
  Eye,
  GitBranch,
  Layers,
  LogIn,
  MapPin,
  MousePointerClick,
  Repeat,
  ShoppingBag,
  ShoppingCart,
  Smartphone,
  Users,
} from 'lucide-react';
import type {
  ConditionKind,
  GroupOperator,
} from '@/components/tree-dnd/tree-dnd-types';
import { HIDDEN_CONDITION_KINDS } from '@/components/tree-dnd/tree-dnd-conditions/registry';

export type AddNodeCatalogId = 'groupAnd' | 'groupOr' | ConditionKind;

export type AddNodeCatalogSection = 'groups' | 'filters';

export type AddNodeCatalogItem = {
  id: AddNodeCatalogId;
  section: AddNodeCatalogSection;
  icon: LucideIcon;
  groupOperator?: GroupOperator;
};

export function isConditionKind(id: AddNodeCatalogId): id is ConditionKind {
  return id !== 'groupAnd' && id !== 'groupOr';
}

const ALL_ADD_NODE_CATALOG: AddNodeCatalogItem[] = [
  { id: 'groupAnd', section: 'groups', icon: Layers, groupOperator: 'AND' },
  { id: 'groupOr', section: 'groups', icon: GitBranch, groupOperator: 'OR' },
  { id: 'installedApp', section: 'filters', icon: Smartphone },
  { id: 'boughtProduct', section: 'filters', icon: ShoppingBag },
  { id: 'receivedNotification', section: 'filters', icon: Bell },
  { id: 'clickedCampaign', section: 'filters', icon: MousePointerClick },
  { id: 'rfmGroup', section: 'filters', icon: Users },
  { id: 'lastNotificationAt', section: 'filters', icon: Clock },
  { id: 'lastAppAccessAt', section: 'filters', icon: LogIn },
  { id: 'viewedProduct', section: 'filters', icon: Eye },
  { id: 'location', section: 'filters', icon: MapPin },
  { id: 'lastOrder', section: 'filters', icon: ShoppingCart },
  { id: 'orderFrequency', section: 'filters', icon: Repeat },
  { id: 'totalSpend', section: 'filters', icon: DollarSign },
  { id: 'hasNotificationsEnabled', section: 'filters', icon: BellRing },
];

export const ADD_NODE_CATALOG = ALL_ADD_NODE_CATALOG.filter(
  (item) => !isConditionKind(item.id) || !HIDDEN_CONDITION_KINDS.has(item.id)
);
